import styles from "./bussiness.module.css";
import { BiAlignRight } from "react-icons/bi";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { AiOutlineStop, AiOutlineCheckCircle } from "react-icons/ai";
import { RiDeleteBack2Line } from "react-icons/ri";
import { RiOrderPlayLine, RiPagesLine } from "react-icons/ri";
import { BiCoinStack } from "react-icons/bi";
import { connection } from "utils/apiConnection.ts";
import { NavLink, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Modal from "./modal/Modal";
import logo from "../../assets/images/logo-sabadi.png";
import Swal from "sweetalert2";

import ManagementCommission from "./modal/ManagementCommission.jsx";

const BoxCustomer = ({
  item,
  otherInfo,
  setOtherInfo,
  index,
  customers,
  selectedItem,
  setSelectedItem,
  allProductTags,
  allUsers,
  links,
  setEditModalData,
  editModalData,
  activeHandler
  // chars,
}) => {
  const [lineOption, setLineOption] = useState([]);
  const [show, setShow] = useState(false);
  const editHandler = () => {
    setSelectedItem(item.suppliers__id);

    let revLink = links.reverse();
    // let text = chars[index].main_admin_uid;
    let text = item.main_admin_uid;
    const myArray = text.split(" ");

    let selectedtags = allUsers.filter(value => {
      for (let index = 0; index < myArray.length; index++) {
        if (myArray[index] == value.value) return true;
      }
      return false;
    });

    // let selectedlinks = allProductTags.filter((value) => {
    //   for (let i = 0; i < revLink[index].length; i++) {
    //     if (revLink[index][i].suppliers_line_id == value.value) return true;
    //   }
    //   return false;
    // });

    setOtherInfo({
      suppliers__id: item.suppliers__id,
      bank_info: item.bank_info,
      site: item.site,
      instagram: item.instagram,
      title: item.title,
      token: item.token,
      // main_admin_uid: [...selectedtags],
      main_admin_uid: item.main_admin_uid,
      user_mobile: item.user_mobile,
      fullname: item.fullname,
      cover_file_id: item.cover_file_id,
      logo_file_id: item.path,
      main_cat: item.main_cat,
      // line_ids: [...selectedlinks],
      line_ids: lineOption,
      description: item.description,
      //   endTime:item.endTime,
      // startTime:item.startTime,
      start_hour: item.start_hour,
      start_min: item.start_min,
      finish_hour: item.finish_hour,
      finish_min: item.finish_min,
      tell1: item.tell1,
      tell2: item.tell2,
      email: item.email,
      mobile: item.mobile,
      address: item.address,
      min_order_amount: item.min_order_amount
      // suppliers__id: chars[index].suppliers__id,
      // title: chars[index].title,
      // token: chars[index].token,
      // main_admin_uid: [...selectedtags],
      // user_mobile: chars[index].user_mobile,
      // fullname: chars[index].fullname,
      // cover_file_id: chars[index].cover_file_id,
      // logo_file_id: chars[index].path,
      // main_cat: chars[index].main_cat,
      // line_ids: [...selectedlinks],
      // description: chars[index].description,
      // //   endTime:chars[index].endTime,
      // // startTime:chars[index].startTime,
      // start_hour: chars[index].start_hour,
      // start_min: chars[index].start_min,
      // finish_hour: chars[index].finish_hour,
      // finish_min: chars[index].finish_min,
      // tell1: chars[index].tell1,
      // tell2: chars[index].tell2,
      // email: chars[index].email,
      // mobile: chars[index].mobile,
      // address: chars[index].address,
      // min_order_amount: chars[index].min_order_amount,
    });
  };
  const stopHandler = () => {
    setSelectedItem(item.suppliers__id);
    // setSelectedItem(index);
  };
  const showLine = array => {
    let a = array.map((value, index) => {
      return (
        <p>
          {value.label}
          {index != array.length - 1 ? " , " : ""}
        </p>
      );
    });

    return a;
  };
  const activeHandlerModal = () => {
    Swal.fire({
      icon: "warning",
      title: "آیا از فعال سازی این کسب و کار مطمئن هستید؟",
      showCancelButton: true,
      cancelButtonText: "انصراف",
      confirmButtonText: "فعال سازی",
      cancelButtonColor: "#EF394E",
      confirmButtonColor: "#439B58"
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        activeHandler(item.suppliers__id);
      }
    });
  };
  useEffect(() => {
    let temp = [];
    let x =
      links.length > 0 &&
      allProductTags.length > 0 &&
      links.filter(l => {
        let y = allProductTags.find(a => a.value == l.suppliers_line_id);
        temp = [...temp, y];
        setLineOption(temp);
      });
  }, [links, allProductTags]);
  // console.log("links:", links);
  // console.log("allProductTags:", allProductTags);
  // console.log("lineOption", lineOption);
  // console.log("item", item);
  // console.log("customer", customers);
  return (
    <div
      className={`  w-100  ${item.main_status == 0 ? styles.sec : styles.sec2}`}
      style={{
        borderRadius: " 10px"
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={`${styles.BlueCol} ${styles.logo}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            لوگو
          </p>
          <div
            className={` d-flex justify-content-center align-items-center my-auto ${styles.nameRow}`}
          >
            <img
              style={{
                width: "60px",
                height: "58px",
                marginTop: "8px",
                borderRadius: "50%"
              }}
              src={`${
                item.path != null
                  ? `http://sabadi.tatdemo.ir/${item.path}`
                  : logo
              }`}
            />
          </div>
        </div>
        <div className={`${styles.BlueCol} ${styles.title}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عنوان
          </p>
          <p
            className={` d-flex justify-content-center align-items-center my-auto ${styles.nameRow}`}
          >
            {item.title}{" "}
          </p>
        </div>
        {/* <div className={`${styles.BlueCol} ${styles.instagram}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            اینستاگرام
          </p>
          <p
            className={` d-flex justify-content-center align-items-center my-auto ${styles.nameRow}`}
          >
            {item.instagram != "" ? item.instagram : "-----------"}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.site}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            آدرس وبسایت
          </p>
          <p
            className={` d-flex justify-content-center align-items-center my-auto ${styles.nameRow}`}
          >
            {item.site != "" ? item.site : "-----------"}
          </p>
        </div> */}

        <div className={`${styles.BlueCol} ${styles.description}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            توضیحات
          </p>
          <p
            className={` d-flex justify-content-center align-items-center my-auto ${styles.nameRow}`}
          >
            {item.description != "" ? item.description : "-----------"}
          </p>
        </div>

        <div className={`${styles.BlueCol} ${styles.line}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            لاین های کسب و کار
          </p>
          <p
            className={` d-flex flex-wrap justify-content-center align-items-center  my-auto ${styles.nameRow}`}
          >
            {showLine(lineOption)}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.statistic}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد سفارشات تحویل شده
          </p>
          <p
            className={` d-flex my-auto justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.complate_order_count)}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.statistic}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد سفارشات فعال
          </p>
          <p
            className={`my-auto d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.min_order_amount)}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.statistic}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد سفارشات کنسل شده
          </p>
          <p
            className={`my-auto d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.canceled_order_count)}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.statistic}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            مجموع فروش
          </p>
          <p
            className={`my-auto d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.total_saled_amount)}
          </p>
        </div>

        <div className={`${styles.BlueCol} ${styles.line}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModalE`}
              // onClick={editHandler}
              onClick={() => {
                // console.log("dd", otherInfo);

                editHandler();
                setEditModalData({ ...customers, lineOption: lineOption });
              }}
            >
              <h4 data-tip="ویرایش کسب و کار">
                <FiEdit className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#deleteBussinessModal`}
              onClick={stopHandler}
            >
              <h4 data-tip="حذف  کسب و کار">
                <RiDeleteBack2Line className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            {item.main_status == 0 ? (
              <p
                className={styles.tlg}
                data-bs-toggle="modal"
                data-bs-target={`#stopBussinessModal`}
                onClick={stopHandler}
              >
                <h4 data-tip="توقف ">
                  <AiOutlineStop className={styles.tlg1} />
                </h4>
                <ReactTooltip />
              </p>
            ) : (
              <p
                className={styles.tlg}
                data-bs-toggle="modal"
                onClick={() => {
                  activeHandlerModal();
                }}
              >
                <h4 data-tip="فعال  ">
                  <AiOutlineCheckCircle className={styles.tlg1} />
                </h4>
                <ReactTooltip />
              </p>
            )}
            <Link to={`/admin-panel/${item.suppliers__id}`} target="_blank">
              <h4 data-tip="پنل ادمین ">
                <BiAlignRight
                  style={{
                    color: item.main_status == "0" ? "white" : "#1a3764"
                  }}
                  className={styles.tlg1}
                />
              </h4>
              <ReactTooltip />
            </Link>
            <Link to={`/supplier/${item.suppliers__id}`} target="_blank">
              <h4 data-tip=" ویترین فروشگاه ">
                <RiPagesLine
                  className={`${styles.tlg1} `}
                  style={{
                    color: item.main_status == "0" ? "white" : "#1a3764"
                  }}
                />
              </h4>
              <ReactTooltip />
            </Link>
            <p
              className={styles.tlg}
              // data-bs-toggle="modal"
              // data-bs-target={`#commissionModal`}
              // onClick={stopHandler}
              onClick={() => {
                setShow(true);
                editHandler();
              }}
            >
              <h4 data-tip="مدیریت کمیسیون">
                <BiCoinStack className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>

            <ManagementCommission
              otherInfo={otherInfo}
              show={show}
              setShow={setShow}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxCustomer;
